var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.messages.length)?_c('v-row',_vm._l((_vm.messages),function(message,i){return _c('v-col',{key:i,attrs:{"cols":"12"}},[_c('v-alert',{attrs:{"type":"error"}},[_vm._v(_vm._s(message))])],1)}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }